import { Container, Row, Col } from "react-bootstrap";
import { OrgIdContext, ClientTypes, CustomerRelations } from "../../../store/orgId_context";
import classes from "./Packages.module.scss"
import Package from "./Package";
import { useContext, useEffect, useState } from "react";
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PeopleIcon from '@mui/icons-material/People';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import { DDD, E2Data} from "../../../lib/ddd/ddd";
import PackageFull from "./PackageFull";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle,FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from "@mui/material";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import ReceiptIcon from '@mui/icons-material/Receipt';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PackageSelectRow from "./PackageSelectRow";
import LoadingDots from "../../UI/LoadingDots";
import GenericModal from "../../UI/GenericModal";
import FundPayPackage from "./FungPayPackage";
import PaymentIcon from '@mui/icons-material/Payment';
import { styled } from '@mui/material/styles';
import InvoiceSwitch from "./InvoiceSwitch";
import PackageSelectRow2 from "./PackageSelectRow2";
import { useTranslation } from "react-i18next";


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data_EU_AOrg = new E2Data("EU_AOrg");

const IssuePackages = {
    EInvoiceOnly : "EInvoiceOnly",
    EInvoiceBasic : "EInvoiceBasic",
    EInvoiceProfessional : "EInvoiceProfessional"
}
const IssuesFiscPackages = {
    Only : "Only",
    Basic :"Basic",
    FiscAndB2B : "FiscAndB2B",
    PaymentAndFisc : "PaymentAndFisc"
}
const RecievedPackages = {
    Basic : "Basic",
    Pro : "Pro"
}
const ArchivePackages = {
    TBD : "TBD"
}

const Packages = ({wrapIt=true, showOnly}) =>{
    const [isLoading, setIsLoading] = useState();
    const [issuePackages, setIssuePackages] = useState();
    const [recievePackages, setRecievePackages] = useState();
    const [fiscPackages, setFiscPackages] = useState();
    const [confirmDialog, setConfirmDialog] = useState();
    const [orderPackage, setOrderPackage] = useState();
    const [orderPackageData, setOrderPackageData] = useState();
    const [error, setError] = useState();
    const [forceReload, setForceReload] = useState();

    const [issueAmounts, setIssueAmounts] = useState();
    const [issueAmount, setIssueAmount] = useState();
    const [issuePaymentType, setIssuePaymentType] = useState("Invoice");
    const [issuePayType, setIssuePayType] = useState("Monthly");

    const [recieveAmounts, setRecieveAmounts] = useState();
    const [recieveAmount, setRecieveAmount] = useState();
    const [recievePaymentType, setRecievePaymentType] = useState("Invoice");
    const [recievePayType, setRecievePayType] = useState("Monthly");

    const [fiscAmounts, setFiscAmounts] = useState();
    const [fiscAmount, setFiscAmount] = useState();
    const [fiscPaymentType, setFiscPaymentType] = useState("Invoice");
    const [fiscPayType, setFiscPayType] = useState("Monthly");
    const [missingFunds, setMissingFunds] = useState();
    const {t} = useTranslation()
    let [searchParams] = useSearchParams();

    const [showPaymentModal, setShowPaymentModal] = useState();

    const { isIntegrator, ISVCustomer, sessionInfo, clientType, customerRelation, setCustomerRelationHandler, aboutOrgId, setSessionInfoHandler } = useContext(OrgIdContext);
    useEffect(() => {
        setIsLoading(true);
        let _showOnly = searchParams.get("forservice");
        if(["iei", "rei", "fisc"].indexOf(_showOnly?.toLocaleLowerCase())>-1)
            showOnly =  _showOnly;

        const ddd = new DDD(apiRequestAddress);
        let service = window.location.hostname.includes("dddinvoices.com") ? "dddinvoices.com" : "e-invoices.online";
        //let service = "dddinvoices.com";
        
        if(showOnly){
            loadPackages(service, showOnly, getTypeSetter(showOnly), getTypeAmountsSetter(showOnly)).then(() => {
                setIsLoading(false);
            });
        }else{
            let count =0;
            loadPackages(service, "iei", setIssuePackages, setIssueAmounts).then(() => {
                count++;
                if(count>2)
                    setIsLoading(false);
            });
            loadPackages(service, "rei", setRecievePackages, setRecieveAmounts).then(() => {
                count++;
                if(count>2)
                    setIsLoading(false);
            });
            loadPackages(service, "fisc", setFiscPackages, setFiscAmounts).then(() => {
                count++;
                if(count>2)
                    setIsLoading(false);
            });
        }
    }, [showOnly]);

    const getTypeSetter = (type) =>{
        switch(type){
            case "iei":
                return setIssuePackages;
            case "rei":
                return setRecievePackages;
            case "fisc":
                return setFiscPackages;
            default:
                return null;
        }
    }
    const getTypeAmountsSetter = (type) => {
        switch(type){
            case "iei":
                return setIssueAmounts;
            case "rei":
                return setRecieveAmounts;
            case "fisc":
                return setFiscAmounts;
            default:
                return null;
        }
    }

    const loadPackages = (service, packageType, setter, amountsSetter) => {
        let args = {Service : service, ClientType : clientType, ClientTypePrecisely : null, PackageType : packageType};
        const ddd = new DDD(apiRequestAddress);
        return new Promise((resolve, reject) => {
            ddd.Rpc_ExecuteExtension("EUeInvoices.ListOfPackages", args).then(res => {
                let packages = [];
                let data = res?.result?.data;
                if(!data || data.length ===0){
                    setter(packages);
                    return resolve();
                }
                packages = [...data];
                packages = setupGroupings(packages,amountsSetter);
                setter(packages.length > 0 ? packages : null);
                resolve();
            })
        });
    }

    const setupGroupings = (packages, amountSetter) => {
        let groups = false;
        for(let p of packages){
            if(p.ByGroup === true){
                groups= true;
                break;
            }
        }

        if(groups){
            let groupedObj = {};
            for(let p of packages){

                if(!groupedObj.hasOwnProperty(p["Package__Code"]))
                    groupedObj[p["Package__Code"]] = [];

                    groupedObj[p["Package__Code"]].push(p);
            }

            let _ret = [];
            for(const gr in groupedObj){
                _ret.push(groupedObj[gr]);
            }
            amountSetter(getAmountsObjFromGroup(_ret));
            return _ret;
        }

        return packages;
    }

    const getAmountsObjFromGroup = (grouped) => {
        if(!grouped || grouped.length===0)
            return [];
        let ret = {};
        for(let pg of grouped){
            for(let p of pg){
                if(p.hasOwnProperty("QuantityPerMonth"))
                    ret[p["QuantityPerMonth"]] = p["QuantityPerMonthVS"]  || p["QuantityPerMonth"];
            }
        }

        let _ret = [];
        for(const prop in ret){
            _ret.push({value : parseFloat(prop), title : ret[prop]})
        }

        return _ret;
    }

    const renderPackages = (packages, type, amount, paymentType, payType) => {
        const rows = [];
        let _packages = [];
        if(amount){
            packages.forEach(pg => {
                pg.forEach(p => {
                    if(p["QuantityPerMonth"] === amount)
                        _packages.push(p);
                })
            });
        }else{
            packages.forEach(item => _packages.push(item));
        }
        //console.log(_packages);
        for(let i=0;i < _packages.length;i=i+4){
            const slice = _packages.slice(i, i+4);
            rows.push(renderPackageRow(slice, type, amount, paymentType, payType));
        }
        return <>{rows}</>
    }

    const renderPackageRow = (packages, type, amount, paymentType, payType) => {
        return(
            <Row>
                {packages.length > 0 &&
                    <Col className = "col-12 col-md-12 col-xl-3">
                        <PackageFull packageData={packages[0]} packageType={"basic"} type={type} onOrder={onOrder} reload={forceReload} amount={amount} paymentType={paymentType} payType={payType}/>
                    </Col>
                }
                {packages.length > 1 &&
                    <Col className = "col-12 col-md-12 col-xl-3">
                        <PackageFull packageData={packages[1]} packageType={"premium"} type={type} onOrder={onOrder} reload={forceReload} amount={amount} paymentType={paymentType} payType={payType}/>
                    </Col>
                }
                {packages.length > 2 &&
                    <Col className = "col-12 col-md-12 col-xl-3">
                        <PackageFull packageData={packages[2]} packageType={"business"} type={type} onOrder={onOrder} reload={forceReload} amount={amount} paymentType={paymentType} payType={payType}/>
                    </Col>
                }
                {packages.length > 3 &&
                    <Col className = "col-12 col-md-12 col-xl-3">
                        <PackageFull packageData={packages[3]} packageType={"professional"} type={type} onOrder={onOrder} reload={forceReload} amount={amount} paymentType={paymentType} payType={payType}/>
                    </Col>
                }
            </Row>
        )
    }

    const onOrder = (data, type, paymentType, payType) => {
        console.log(paymentType);
        const args = {
            PackageType : type,
            PaymentType : paymentType,
            PayType : payType,
            PackageId : data.Id
        }

        /*if(paymentType === "Invoice"){
            setOrderPackage(args);
            setOrderPackageData(data);
            setConfirmDialog(true);
        }else{
            setOrderPackage(args);
            setOrderPackageData(data);
            setShowPaymentModal(true);
        }*/
        setOrderPackage(args);
        setOrderPackageData(data);
        setConfirmDialog(true);
    }

    const onConfirmPackageChange = () =>{
        setConfirmDialog(false);
        if(!orderPackage || !orderPackageData)
            return;

        //if(!hasFunds()) return setMissingFunds(true);

        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.ChangePackageNew", orderPackage).then(res => {
            if(res?.result?.Status==="Error"){
                setError(res.result.Reason);
                setTimeout(() => {setError(null);}, 5000);
            }else{
                ddd.InvalidateSessionExtensions().then(() => {
                    ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
                        if(res?.result)
                          setSessionInfoHandler(res.result);

                        setTimeout(() => {setForceReload(new Date())}, 500);
                    });
                });
            }
        })
    }

    const hasFunds = () => {
        if(!sessionInfo?.Extended?.AccountBalance)
            return false;
        const availableFunds=  parseFloat(sessionInfo.Extended.AccountBalance);
        let cost = orderPackage.PayType === "Monthly" ? parseFloat(orderPackageData.PricePerMonth) : parseFloat(orderPackageData.PricePerYear);
        if(isNaN(cost)) cost = 0;
        
        return availableFunds >= cost;
    }
    const onCancelConfirm = () =>{
        setConfirmDialog(false);
        setOrderPackage(null);
        setOrderPackageData(null);
    }

    const paymentCompleted = (packageData, checkoutId) =>{
        onConfirmPackageChange();
    }
    
    return(
        <>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmDialog}>
            <DialogTitle>{t("Confirm package change")}</DialogTitle>
            <DialogContent dividers>
                {("Are you certain you wish to order package")}: {orderPackageData?.PackageName}, {orderPackage?.PayType}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onCancelConfirm}>
                Cancel
                </Button>
                <Button onClick={onConfirmPackageChange}>Ok</Button>
            </DialogActions>
        </Dialog>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={missingFunds}>
            <DialogTitle>{t("Missing funds")}</DialogTitle>
            <DialogContent dividers>
                {("Not enough funds to order this package. Please visit the Overview tab to add more funds.")}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setMissingFunds(false)}>Ok</Button>
            </DialogActions>
        </Dialog>
        
        <GenericModal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} title="Order package" icon={<PaymentIcon/>}>
            <FundPayPackage onPaymentCompleted={paymentCompleted} onClose={() => setShowPaymentModal(false)} packageData={orderPackageData} packageArgs={orderPackage}/>
        </GenericModal>
        <Container>
            {isLoading && <LoadingDots/>}
            {!isLoading && issuePackages?.length > 0 && <>
                <h2>Issued invoices - package</h2>
                {sessionInfo?.Extended?.CurrentPackages?.IEI_Package && 
                    <div className="alert alert-info" role="alert">{t("Currently active")}: <span className="fw-bold">{sessionInfo?.Extended?.CurrentPackages?.IEI_Package.PackageCode}, {sessionInfo?.Extended?.CurrentPackages?.IEI_Package.PayType}</span></div>
                }
                <PackageSelectRow2  amounts={issueAmounts} type="IEI" onAmountChange={(val) => setIssueAmount(val)} onPayTypeChange={(val) => setIssuePayType(val)} onPaymentTypeChange={(val) =>setIssuePaymentType(val)}/>
                <Row>
                    {error && <div class="alert alert-danger" role="alert">
                        {error}
                    </div>}
                </Row>
                {renderPackages(issuePackages, "IEI", issueAmount, issuePaymentType, issuePayType)}
            </>}
            {!isLoading && recievePackages?.length > 0 && <>
                <h2>Received invoices - package</h2>
                {sessionInfo?.Extended?.CurrentPackages?.REI_Package && 
                    <div className="alert alert-info" role="alert">{t("Currently active")}: <span className="fw-bold">{sessionInfo?.Extended?.CurrentPackages?.REI_Package.PackageCode}, {sessionInfo?.Extended?.CurrentPackages?.REI_Package.PayType}</span></div>
                }
                <PackageSelectRow2 amounts={recieveAmounts} type="REI" onAmountChange={(val) => setRecieveAmount(val)} onPayTypeChange={(val) => setRecievePayType(val)} onPaymentTypeChange={(val) =>setRecievePaymentType(val)}/>
                <Row>
                    {error && <div class="alert alert-danger" role="alert">
                        {error}
                    </div>}
                </Row>
                {renderPackages(recievePackages, "REI", recieveAmount, recievePaymentType, recievePayType)}
            </>}
            {!isLoading && fiscPackages?.length > 0 && <>
                <h2>Fiscalization only - package</h2>
                {sessionInfo?.Extended?.CurrentPackages?.FISC_Package && 
                    <div className="alert alert-info" role="alert">{t("Currently active")}: <span className="fw-bold">{sessionInfo?.Extended?.CurrentPackages?.FISC_Package.PackageCode}, {sessionInfo?.Extended?.CurrentPackages?.FISC_Package.PayType}</span></div>
                }
                <PackageSelectRow2 amounts={fiscAmounts} type="FISC" onAmountChange={(val) => setFiscAmount(val)} onPayTypeChange={(val) => setFiscPayType(val)} onPaymentTypeChange={(val) =>setFiscPaymentType(val)}/>
                <Row>
                    {error && <div class="alert alert-danger" role="alert">
                        {error}
                    </div>}
                </Row>
                {renderPackages(fiscPackages, "FISC", fiscAmount, fiscPaymentType, fiscPayType)}
            </>}
            
            {/* <Row>
                <Col className = "col-12 col-md-12 col-lg-4">
                        <Package packageTitle={"e-Invoice Only"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={IssuePackages.EInvoiceOnly} 
                        active={issuePackage === IssuePackages.EInvoiceOnly ?  "true" : "false"} 
                        price="120€"
                        packageMainTitle={"BASIC"}
                        packageType={"basic"}
                        onActivateClick={onActvateClick}>
                            <ul className={classes["pricing-table-ul"]} >
                                <li><JoinFullIcon className={classes["fa"]}/>Legal compliant e-invoice generation	</li>
                                <li><JoinFullIcon className={classes["fa"]}/>Legal compliant corrective document creation (with one referential document)</li>
                                <li><JoinFullIcon className={classes["fa"]}/>Automatic PDF visualization creation</li>
                                <li><JoinFullIcon className={classes["fa"]}/>Automatically sent to Tax Authority (if requested)</li>
                                <li><JoinFullIcon className={classes["fa"]}/>A-invoice & PDF optionally sent to the buyer (all meaningful e-paths, including Peppol)</li>
                                <li><JoinFullIcon className={classes["fa"]}/>All sendings proof data returned to sender</li>
                                <li><JoinFullIcon className={classes["fa"]}/>E-invoice & PDF optionally returned to sender	</li>
                                <li><JoinFullIcon className={classes["fa"]}/><u>No document archiving</u>, no data archiving   (data & documents deleted after 48 hours)	</li>
                                <li><JoinFullIcon className={classes["fa"]}/><u>No later tax reports</u></li>
                            </ul>
                        </Package>
                </Col>
                <Col className = "col-12 col-md-12 col-lg-4">
                        <Package packageTitle={"e-Invoice Basic"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={IssuePackages.EInvoiceBasic} 
                        active={issuePackage === IssuePackages.EInvoiceBasic ?  "true" : "false"} 
                        price="160€"
                        packageMainTitle={"PREMIUM"}
                        packageType={"premium"}
                        onActivateClick={onActvateClick}>
                            <ul className={classes["pricing-table-ul"]} style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li><PeopleIcon className={classes["fa"]}/>All from package e-invoice Only, plus</li>
                                <li><PeopleIcon className={classes["fa"]}/>basic data archiving (in database)</li>
                                <li><PeopleIcon className={classes["fa"]}/>mandatory periodic VAT reports (from invoices' data in database)</li>
                                <li><PeopleIcon className={classes["fa"]}/>generate and send compliant Advance invoices	</li>
                                <li><PeopleIcon className={classes["fa"]}/>generate and send Proforma invoices	</li>
                                <li><PeopleIcon className={classes["fa"]}/>no document archiving </li>
                            </ul>
                        </Package>
                </Col>
                <Col className = "col-12 col-md-12 col-lg-4">
                        <Package packageTitle={"e-Invoice Proffesional"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={IssuePackages.EInvoiceProfessional} 
                        active={issuePackage === IssuePackages.EInvoiceProfessional ?  "true" : "false"} 
                        price="260€"
                        packageMainTitle={"ENTERPRISE"}
                        packageType={"business"}
                        onActivateClick={onActvateClick}>
                            <ul className={classes["pricing-table-ul"]} style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li><PeopleAltIcon className={classes["fa"]}/>All from package e-invoice Basic, plus</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>generate and send legal compliant Credit notes 	</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>use of Advance invoices as a payment method   (on several later invoices)	</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>received e-Invoices	</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>from senders in our service	</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>from Peppol network	</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>from other connected networks	</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>from encripted e-mail server	</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>one simple API to import the received invoices 	</li>
                            </ul>
                        </Package>
                </Col>
            </Row>
            <Row style={{marginTop:"2rem", marginBottom:"1rem"}}>
                <h2>Issued invoices - package for fiscalization:</h2>
            </Row>
            <Row>
                <Col className = "col-12 col-md-12 col-lg-12 col-xl-3">
                <Package packageTitle={"Fiscalization Only"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={IssuesFiscPackages.Only} 
                        price="60€"
                        packageMainTitle={"BASIC"}
                        packageType={"basic"}
                        active={issueFiscPackage === IssuesFiscPackages.Only ?  "true" : "false"} 
                        onActivateClick={onActvateClickFisc}>
                            <ul className={classes["pricing-table-ul"]} style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li><JoinFullIcon className={classes["fa"]}/>legal compliant fiscalization</li>
                                <li><JoinFullIcon className={classes["fa"]}/>fiscalization data returned to sender</li>
                            </ul>
                        </Package>
                </Col>
                <Col className = "col-12 col-md-12 col-lg-12 col-xl-3">
                <Package packageTitle={"Fiscalization Basic"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={IssuesFiscPackages.Basic}
                        price="100€" 
                        packageMainTitle={"PREMIUM"}
                        packageType={"premium"}
                        active={issueFiscPackage === IssuesFiscPackages.Basic ?  "true" : "false"} 
                        onActivateClick={onActvateClickFisc}>
                            <ul className={classes["pricing-table-ul"]} style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li><JoinFullIcon className={classes["fa"]}/>legal compliant fiscalization</li>
                                <li><JoinFullIcon className={classes["fa"]}/>fiscalization data returned to sender</li>
                                <li><JoinFullIcon className={classes["fa"]}/>data archiving (in database)</li>
                                <li><JoinFullIcon className={classes["fa"]}/>mandatory tax reports</li>
                            </ul>
                        </Package>
                </Col>
                <Col className = "col-12 col-md-12 col-lg-12 col-xl-3">
                <Package packageTitle={"Fiscalization and B2C sendings"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={IssuesFiscPackages.FiscAndB2B} 
                        price="160€"
                        packageMainTitle={"PROFESSIONAL"}
                        packageType={"professional"}
                        active={issueFiscPackage === IssuesFiscPackages.FiscAndB2B ?  "true" : "false"} 
                        onActivateClick={onActvateClickFisc}>
                            <ul className={classes["pricing-table-ul"]} style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li><PeopleIcon className={classes["fa"]}/>legal compliant fiscalization</li>
                                <li><PeopleIcon className={classes["fa"]}/>basic data archiving (in database)</li>
                                <li><PeopleIcon className={classes["fa"]}/>mandatory tax reports</li>
                                <li><PeopleIcon className={classes["fa"]}/>invoice generation</li>
                                <li><PeopleIcon className={classes["fa"]}/>invoice visualization</li>
                                <li><PeopleIcon className={classes["fa"]}/>requested fisc result returned to sender as</li>
                                <li><PeopleIcon className={classes["fa"]}/>fisc. data only, as fisc. bill or as fisc. A4 invoice</li>
                                <li><PeopleIcon className={classes["fa"]}/>visualized bill/invoice sent to customers by email</li>
                            </ul>
                        </Package>
                </Col>
                <Col className = "col-12 col-md-12 col-lg-12 col-xl-3">
                <Package packageTitle={"Payment and fiscalization"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={IssuesFiscPackages.PaymentAndFisc} 
                        price="200€"
                        packageMainTitle={"ENTERPRISE"}
                        packageType={"business"}
                        active={issueFiscPackage === IssuesFiscPackages.PaymentAndFisc ?  "true" : "false"} 
                        onActivateClick={onActvateClickFisc}>
                            <ul className={classes["pricing-table-ul"]} style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li><PeopleAltIcon className={classes["fa"]}/>invoice generation</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>invoice visualization</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>invoice is sent to my-bills.online</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>payment confirmation returned to sender</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>legal compliant fiscalization</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>basic data archiving</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>mandatory tax reports</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>requested fisc result returned to sender as</li>
                                <li><PeopleAltIcon className={classes["fa"]}/>fisc. data only, as fisc. bill or as fisc. A4 invoice</li>
                            </ul>
                        </Package>
                </Col>
            </Row>
            <Row style={{marginTop:"2rem", marginBottom:"1rem"}}>
                <h2>Received invoices package</h2>
            </Row> */}
            {/*<Row>
                <Col className = "col-12 col-md-6">
                <Package packageTitle={"Basic"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={RecievedPackages.Basic} 
                        price="200€"
                        active={recievePackage === RecievedPackages.Basic ?  "true" : "false"} 
                        onActivateClick={onActvateClickFisc}>
                            <ul style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li>invoice generation</li>
                            </ul>
                        </Package>
                </Col>
                <Col className = "col-12 col-md-6">
                <Package packageTitle={"Professional"} 
                        icon={<DoNotDisturbIcon/>} 
                        packageKey={RecievedPackages.Pro} 
                        price="200€"
                        active={recievePackage === RecievedPackages.Pro ?  "true" : "false"} 
                        onActivateClick={onActvateClickFisc}>
                            <ul style ={{paddingLeft:"1rem", textAlign:"left"}}>
                                <li>invoice generation</li>
                            </ul>
                        </Package>
                </Col>
            </Row>*/}
        {/*</Container>*/}
        </Container>
        </>
    )
}

export default Packages;